import { enMessages } from './languages/EN.lang';
import { plMessages } from './languages/PL.lang';

export const tuwTranslations = {
  pl: plMessages,
  en: enMessages,
};
